import React from "react";

export const Trash = () => (
<svg
  width="24"
  height="24"
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.4 10.1997V17.3997C16.4 17.718 16.2736 18.0232 16.0486 18.2482C15.8235 18.4733 15.5183 18.5997 15.2 18.5997H8.00005C7.68179 18.5997 7.37656 18.4733 7.15152 18.2482C6.92648 18.0232 6.80005 17.718 6.80005 17.3997V10.1997"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M5 7.7998H18.2"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M11.6001 12V15.6"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M9.19995 12V15.6"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M14 12V15.6"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
  <path
    d="M9.19995 7.7999V5.3999H14V7.7999"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
</svg>
);


